import React from 'react';

const Contact = () => {
    return (
        <div>
            <h1>Contact Component</h1>
        </div>
    )
};

export default Contact;


// WEBPACK FOOTER //
// ./src/components/contact.js